module.exports = "\n<div v-if=\"messages.length\">\n    <div class=\"alert\"\n         v-for=\"message in messages\"\n         :class=\"'alert-' + message.level\">\n        <button type=\"button\"\n                v-on:click.prevent=\"drop(message)\"\n                class=\"close\"\n                data-dismiss=\"alert\"\n                aria-label=\"Fermer\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n\n        <strong>{{ message.title }}</strong> {{ message.message }}\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts.vue
// module id = 486
// module chunks = 0